import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * GA4 SPA page_view tracker.
 *
 * The gtag.js loader and `config` (with `send_page_view: false`) are injected
 * in public/index.html so the tag is present on every prerendered HTML page
 * — including for crawlers that don't execute React. This component is
 * responsible for the SPA-side responsibility only: firing one `page_view`
 * event on every React Router navigation, including the very first paint.
 *
 * Measurement ID: G-9XM1GYF22B
 */
const GA_MEASUREMENT_ID = "G-9XM1GYF22B";

export default function GoogleAnalytics() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        if (typeof window.gtag !== "function") return;
        window.gtag("event", "page_view", {
            send_to: GA_MEASUREMENT_ID,
            page_title: document.title,
            page_location: window.location.href,
            page_path: pathname + search,
        });
    }, [pathname, search]);

    return null;
}
